import axios from "../axios";

const createTransferOutSide = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('admin/withdraw-transaction/createTransferOutSide', params,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default createTransferOutSide;
